<template>
    <Modal v-model="show"
        title="账号信息"
        :width="60"
        @on-visible-change="onShowChange">
        <Spin v-if="$globalSpin"
            size="large"
            fix></Spin>
        <Form ref="userAdminForm"
            :model="userAdminForm"
            :rules="ruleValidate"
            label-position="top"
            class="small-form">
            <Row :gutter="16">
                <Col span="6">
                <FormItem label="登录帐号"
                    prop="userName">
                    <Input v-model="userAdminForm.userName"
                        :readonly="formEditMode===FORM_EDIT_MODE_MODIFY"></Input>
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label="姓名"
                    prop="userAdminName">
                    <Input v-model="userAdminForm.userAdminName"></Input>
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label="所属区域"
                    prop="userAdminAreaUuid">
                    <Select v-model="userAdminForm.userAdminAreaUuid"
                        filterable>
                        <Option v-for="item in areaSource"
                            :key="item.areaUuid"
                            :value="item.areaUuid">{{ item.areaName }}</Option>
                    </Select>
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label="手机"
                    prop="userAdminPhone">
                    <Input v-model="userAdminForm.userAdminPhone"></Input>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="6">
                <FormItem label="审批">
                    <RadioGroup v-model="userAdminForm.userAdminApproval"
                        type="button">
                        <Radio v-for="item in approvalSource"
                            :key="item.val"
                            :label="item.val">{{ item.label }}
                        </Radio>
                    </RadioGroup>
                </FormItem>
                </Col>
                <Col v-if="formEditMode === FORM_EDIT_MODE_CREATE"
                    span="6">
                <FormItem label="密码">
                    <Input v-model="password"
                        type="password"></Input>
                </FormItem>
                </Col>
                <Col v-if="formEditMode === FORM_EDIT_MODE_CREATE"
                    span="6">
                <FormItem label="密码确认">
                    <Input v-model="passwordConfirm"
                        type="password"></Input>
                </FormItem>
                </Col>
            </Row>
        </Form>
        <div slot="footer">
            <Button type="primary"
                @click="onSave">确认</Button>
            <Button type="error"
                @click="show=false">取消</Button>
        </div>
    </Modal>

</template>

<script>
import { APPROVAL_NO, APPROVAL_YES, approvalFormat } from '@/libs/baseModelFormat';
import { FORM_EDIT_MODE_CREATE, FORM_EDIT_MODE_MODIFY } from '@/view/mixins/form-edit-mode';

import {
    adminUserSave,
    getAdminUserDetail,
    pageInit4UserAdminEdit
} from '@/api/modules/account-management/admin-user-management';

export default {
    name: 'AdminUserEdit',
    data() {
        return {
            show: false,
            accountUuid: '',
            FORM_EDIT_MODE_CREATE,
            FORM_EDIT_MODE_MODIFY,
            formEditMode: FORM_EDIT_MODE_CREATE,
            pageLoading: false,
            userAdminForm: {
                userAdminLoginUuid: '',
                userName: '',
                userAdminName: '',
                userAdminAreaUuid: '',
                userAdminContactNumber: '',
                userAdminPhone: '',
                userAdminWechat: '',
                userAdminEmail: '',
                userAdminApproval: APPROVAL_NO
            },
            ruleValidate: {
                userName: [
                    {
                        trigger: 'blur',
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value) {
                                if (value.length >= 3 && value.length <= 20) {
                                    callback();
                                }
                                else {
                                    callback(new Error('长度在3-20个字符之间'));
                                }
                            }
                            else {
                                callback(new Error(' '));
                            }
                        }
                    }
                ],
                userAdminName: [
                    {
                        trigger: 'blur',
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value) {
                                if (value.length >= 2 && value.length <= 20) {
                                    callback();
                                }
                                else {
                                    callback(new Error('长度在2-20个字符之间'));
                                }
                            }
                            else {
                                callback(new Error(' '));
                            }
                        }
                    }
                ],
                userAdminAreaUuid: [
                    { required: true, message: ' ', trigger: 'blur' }
                ],
                userAdminPhone: [
                    { pattern:/^(?:(?:\+|00)86)?1\d{10}$/, required: true, message: '手机号码格式不正确 ', trigger: 'blur' }
                ]
            },
            password: '',
            passwordConfirm: '',
            areaSource: [],
            approvalSource: []
        };
    },
    mounted() {
        // this.init();
    },
    methods: {
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal(accountUuid) {
            this.accountUuid = accountUuid;
            this.show = true;
        },
        init() {
            this.approvalSource = [];
            this.approvalSource.push({ val: APPROVAL_NO, label: approvalFormat(APPROVAL_NO) });
            this.approvalSource.push({ val: APPROVAL_YES, label: approvalFormat(APPROVAL_YES) });

            this.$showGlobalSpin();
            pageInit4UserAdminEdit().then(res => {
                this.$hideGlobalSpin();
                if (res.code === 0) {
                    this.areaSource = res.data.area.records.map(item => {
                        return {
                            areaUuid: item.areaUuid,
                            areaName: item.areaName
                        };
                    });
                    if (this.accountUuid) {
                        this.formEditMode = FORM_EDIT_MODE_MODIFY;

                        getAdminUserDetail(this.accountUuid).then(detail => {
                            if (detail.code === 0) {
                                const info = detail.data.userAdmin;
                                this.userAdminForm.userAdminLoginUuid = info.userAdminLoginUuid;
                                this.userAdminForm.userName = info.userName;
                                this.userAdminForm.userAdminName = info.userAdminName;
                                this.userAdminForm.userAdminAreaUuid = info.userAdminAreaUuid;
                                this.userAdminForm.userAdminContactNumber = info.userAdminContactNumber;
                                this.userAdminForm.userAdminPhone = info.userAdminPhone;
                                this.userAdminForm.userAdminWechat = info.userAdminWechat;
                                this.userAdminForm.userAdminEmail = info.userAdminEmail;
                                this.userAdminForm.userAdminApproval = info.userAdminApproval;
                            }
                        });
                    }
                    else {
                        this.$refs.userAdminForm.resetFields();
                    }
                }
            }).catch(() => {
                this.$hideGlobalSpin();
            });
        },
        onSave() {
            this.$refs.userAdminForm.validate(valid => {
                if (!valid) {
                    this.$Message.error('表单验证失败!');
                    return;
                }

                const data = Object.assign({ formEditMode: this.formEditMode }, this.userAdminForm);
                if (this.formEditMode === FORM_EDIT_MODE_CREATE) {
                    data.password = this.password;
                    data.passwordConfirm = this.passwordConfirm;
                }

                this.$showGlobalSpin();
                adminUserSave(data).then(res => {
                    this.$hideGlobalSpin();
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: '保存成功',
                            onOk: () => {
                                this.show = false;
                                this.$parent.getAdminUserTableRecords();
                            }
                        });
                    }
                });
            });
        }
    }
};
</script>

<style scoped>
</style>
